export default {
  header: {
    home: "Home",
    products: "Products",
    omdService: "ODM Service",
    about: "About Us",
    contact: "Contact",
  },

  homePage: {
    carousel: {
      getSolution: "Consult for Custom Solutions",
      slides: [
        { img: require('@/assets/homePage/homeCarousel/eng_01.jpg') },
        { img: require('@/assets/homePage/homeCarousel/eng_02.jpg') },
        { img: require('@/assets/homePage/homeCarousel/eng_03.jpg') },
        { img: require('@/assets/homePage/homeCarousel/eng_04.jpg') },
      ],
    },
    productCenter: {
      title: "Product Center",
      viewMore: "View More",
      tabs: [
        {
          tab: 0,
          img: require("@/assets/homePage/productSection/p1-001.png"),
          title: "Sports Equipment",
        },
        {
          tab: 1,
          img: require("@/assets/homePage/productSection/p2-001.png"),
          title: "Fascia Relaxation",
        },
        {
          tab: 2,
          img: require("@/assets/homePage/productSection/p3-001.png"),
          title: "Health Monitoring",
        },
      ],
    },

    about: {
      title: "About Us",
      companyName: 'Huizhou Xingwei Intelligent Technology Co., Ltd.',
      description: 'Huizhou Xingwei Intelligent Technology',
      descriptions: 'Founded in 2021, Huizhou Xingwei Intelligent Technology Co., Ltd. is a national high-tech enterprise focusing on the “sports and health” sector. The company operates an 8,000㎡ self-owned factory and has a professional team of 150+ members (covering design, R&D, manufacturing, and after-sales). With integrated capabilities of “R&D–Manufacturing–Service” and a dual-engine model driven by “independent R&D + customized services,” the company is able to deliver end-to-end product solutions across sports equipment, relaxation massage, and health monitoring.',
      moreButton: "View More",
      stats: [
        { number: '8000m²', label: 'Factory Area' },
        { number: '150+', label: 'Professional Team' },
        { number: '20+', label: 'Patents' },
        { number: '2,000,000+', label: 'Annual Production Capacity' },
        { number: '8', label: 'Assembly Lines' },
        { number: '2021', label: 'Company Established' }
      ],
    },
  },

  productCenter: {
    title: "Product Center",
    subtitle:
      "One-stop full chain service system, professional design and development to create customized solutions.",
    tabs: [
      {
        key: "sports",
        label: "Sports Equipment",
        products: [
          { img: require('@/assets/productCenter/sport01.png'), title: 'Standard Hula Hoop' },
          { img: require('@/assets/productCenter/sport02.png'), title: 'Smart LED Hula Hoop' },
          { img: require('@/assets/productCenter/sport03.png'), title: 'Smart Color Screen Hula Hoop' },
          { img: require('@/assets/productCenter/sport04.png'), title: 'LED Jump Rope' },
          { img: require('@/assets/productCenter/sport05.png'), title: 'Smart Jump Rope' },
          { img: require('@/assets/productCenter/sport06.png'), title: 'Smart Jump Rope' },
          { img: require('@/assets/productCenter/sport07.png'), title: 'Smart Color Screen Jump Rope' },
          { img: require('@/assets/productCenter/sport08.png'), title: 'Exam Training Jump Rope' },
          { img: require('@/assets/productCenter/sport09.png'), title: 'Kids Jump Rope' }

        ]
      },
      {
        key: "module",
        label: "Fascia Relaxation",
        products: [
          { img: require('@/assets/productCenter/module01.png'), title: 'Electric Fascia Ball' },
          { img: require('@/assets/productCenter/module02.png'), title: 'Electric Peanut Ball' },
          { img: require('@/assets/productCenter/module03.png'), title: 'Heated Mini Fascia Gun' },
          { img: require('@/assets/productCenter/module04.png'), title: 'Fascia Gun' },
          { img: require('@/assets/productCenter/module05.png'), title: 'Fascia Gun' },
          { img: require('@/assets/productCenter/module06.png'), title: 'Fascia Gun' },

        ],
      },
      {
        key: "industry",
        label: "Health Monitoring",
        products: [
          { img: require('@/assets/productCenter/screen01.png'), title: 'Weighing Scale' },
          { img: require('@/assets/productCenter/screen02.png'), title: 'Body Fat Scale' },
          { img: require('@/assets/productCenter/screen03.png'), title: 'Body Fat Scale' },
          { img: require('@/assets/productCenter/screen04.png'), title: 'Body Fat Scale' },
          { img: require('@/assets/productCenter/screen05.png'), title: 'Body Fat Scale (WiFi)' },
          { img: require('@/assets/productCenter/screen06.png'), title: 'ITO Coated Body Fat Scale' },
          { img: require('@/assets/productCenter/screen07.png'), title: 'ITO Coated Body Fat Scale' },
          { img: require('@/assets/productCenter/screen08.png'), title: '8-Electrode Body Fat Scale' },
          { img: require('@/assets/productCenter/screen09.png'), title: 'Solar-Powered Body Fat Scale' },

        ],
      },
    ],
  },

  contactUs: {
    carousel: {
      image: require("@/assets/contactUs/new_carousel.jpg"),
      alt: "Contact Us",
      title_chi: "Contact Us",
      title_eng: "Contact us",
    },
    info: {
      desc: '<span class="desc_bold">Recruitment</span><br /><br />No matter who you are, where you come from, or what expertise you have, as long as you are positive and dare to work hard, you are the partner we are looking for!<br />Here, the sky is yours to soar, the ocean is yours to swim, and the land is yours to gallop. This is a boundless world of creativity and a stage for talent.<br />All we ask for is your enthusiasm and wisdom.<br />We sincerely invite you to join us, work together, and share the joy of harvest. We look forward to your arrival!',
      items: [
        {
          label: "Contact",
          value: "Ms.Liu",
          icon: require("../../assets/contactUs/person.png"),
        },
        {
          label: "WeChat yanxing",
          value: "18126338737",
          icon: require("../../assets/contactUs/wechat.png"),
        },
        {
          label: "Email",
          value: "sales@yxted.com",
          icon: require("../../assets/contactUs/email.png"),
        },
        {
          label: "Address",
          value:
            "Building 8, Tonghu Digital Science and Innovation Industrial Park, Huicheng District, Huizhou City, Guangdong Province, China",
          icon: require("../../assets/contactUs/address.png"),
        },
      ],
      map: {
        address: "Building 8, Tonghu Digital Science and Innovation Industrial Park, Huicheng District, Huizhou City, Guangdong Province, China",
      },
    },
    contactForm: {
      title: "Leave your question, we will respond promptly",
      emailPlaceholder: "Email:",
      subjectPlaceholder: "Subject:",
      messagePlaceholder: "Message:",
      submitButton: "Submit",
    },
  },

  aboutUs: {
    carousel: {
      image: require("@/assets/aboutUs/carousel.jpg"),
      alt: "Company Picture",
    },

    intro: {
      title: "Company Introduction",
      companyName: "Huizhou Xingwei Intelligent Science & Technology Co., Ltd.",
      description: '&emsp;&emsp;Huizhou Xingwei Intelligent Technology Co., Ltd., founded in 2021, is a national high-tech enterprise focusing on the “sports and health” sector. The company operates an 8,000㎡ self-owned factory with a professional team of 150+ members (covering design, R&D, manufacturing, and after-sales), building integrated capabilities of “R&D–Manufacturing–Service” and forming a dual-engine model driven by “independent R&D + customized services.” This enables us to deliver end-to-end product solutions across sports equipment, relaxation massage, and health monitoring.<br>&emsp;&emsp;Innovation has always been the core engine of Xingwei Intelligent. With 20+ patents, the company promotes the upgrade of products from single functions to an “intelligent ecosystem” through the deep integration of hardware, software, and data.<br>&emsp;&emsp;Looking ahead, the company will continue to be driven by technological innovation and guided by user needs, further strengthening its capability in providing “all-scenario sports and health solutions.” We aim to help users achieve scientific full-cycle management of “exercise–relaxation–health,” and to become a global leader in intelligent hardware products for the sports and health industry.',
      introduceImage: require("@/assets/aboutUs/introduce.jpg"),
      stats: [
        { number: '8000m²', label: 'Factory Area' },
        { number: '150+', label: 'Professional Team' },
        { number: '20+', label: 'Patents' },
        { number: '2,000,000+', label: 'Annual Production Capacity' },
        { number: '8', label: 'Assembly Lines' },
        { number: '2021', label: 'Company Established' }
      ]
    },

    video: {
      backgroundImage: require("@/assets/aboutUs/vedio_bg.png"),
      playButtonImage: require("@/assets/aboutUs/vedio_btn.png"),
      playButtonAlt: "Play Video",
      unsupportedMessage: "Your browser does not support video playback.",
    },

    culture: {
      title: "Company Culture",
      visionAlt: "Vision",
      vision: "Vision",
      visionDesc: "Provide high-quality products and services for the health of millions of families around the world",
      missionAlt: "Mission",
      mission: "Mission",
      missionDesc: "Enhance product performance through innovation and improve the quality of life with products",
      coreValuesAlt: "Core Values",
      coreValues: "Core Values",
      coreValuesDesc:
        "Openness, Inclusiveness, Cooperation, Win-Win<br/>Self-Driven, Integrity, Responsibility",
    },

    laboratory: {
      title: "Our Laboratory",
      devices: [
        { img: require('@/assets/aboutUs/devices_all/dev01.png'), label: 'Cable Swing Tester' },
        { img: require('@/assets/aboutUs/devices_all/dev02.png'), label: 'Constant Temperature Humidity Chamber' },
        { img: require('@/assets/aboutUs/devices_all/dev03.png'), label: 'Thermal Shock Chamber' },
        { img: require('@/assets/aboutUs/devices_all/dev04.png'), label: 'UV Weathering Tester (Tilted Tower Type)' },
        { img: require('@/assets/aboutUs/devices_all/dev05.png'), label: 'Salt Spray Tester' },
        { img: require('@/assets/aboutUs/devices_all/dev06.png'), label: 'Simulated Transport Vibration Table' },
        { img: require('@/assets/aboutUs/devices_all/dev07.png'), label: 'Single-Arm Drop Tester' },
        { img: require('@/assets/aboutUs/devices_all/dev08.png'), label: 'Electrodynamic Vibration System' },
        { img: require('@/assets/aboutUs/devices_all/dev09.png'), label: 'RCA Tape Abrasion Tester' },
        { img: require('@/assets/aboutUs/devices_all/dev10.png'), label: 'Multi-functional Alcohol Rub Tester' },
        { img: require('@/assets/aboutUs/devices_all/dev11.png'), label: 'Melt Flow Indexer' },
        { img: require('@/assets/aboutUs/devices_all/dev12.png'), label: 'Tensile Testing Machine' }
      ]
    },
  },

  odm: {
    odmCarousel: {
      title: "Provide End-to-End Product Solutions",
    },
    odmIntroduce: {
      title: "ODM Service Introduction",
      subtitle: "Understand ODM at a glance",
      introImg: require('@/assets/solution/eng_introduce.png'),
    },
    serviceDeliver: {
      sectionTitle: 'What Can We Provide?',
      desc: 'Leveraging 20+ patented technologies, mass production experience with 100+ clients, and validation by renowned brands, we deliver end-to-end product solutions covering sports equipment, relaxation massage, and health monitoring.',
      cards: [
        {
          title: 'End-to-End Product Solutions',
          text: 'Providing comprehensive product solutions across sports equipment, relaxation massage, and health monitoring.'
        },
        {
          title: 'Integrated Capabilities',
          text: 'Building seamless “R&D–Manufacturing–Service” integration.'
        },
        {
          title: 'Dual-Engine Model',
          text: 'A dual-engine model driven by “independent R&D + customized services.”'
        }
      ]
    }

  },

  footer: {
    info: {
      phone: "18126338737",
      contact_person: "Contact: Ms.Liu",
      email: "Email: sales{'@'}yxted.com",
      address: '<div class="address-container"><span class="address-label">Address:</span><span class="address-content">Building 8, Tonghu Digital Science and Innovation Industrial Park, Huicheng District, Huizhou City, Guangdong Province, China</span></div>',
    },

    products: {
      title: "Product Center",
      sport: 'Sports Equipment',
      module: 'Fascia Relaxation',
      screen: 'Health Monitoring',
    },

    odmService: {
      title: "ODM Services",
      omd: "ODM Services",
      advantage: "Our Advantages",
      laboratory: "Our Laboratory",
    },

    about: {
      title: "About Us",
      company: "Company Profile",
      vedio: "Video Introduction",
      culture: "Company Culture",
    },
    contact: {
      title: "Contact Us",
      informa: "Basic information",
      method: "contact details",
    },
    copyright: "Copyright©2025 Huizhou Xingwei Intelligent Science & Technology Co., Ltd. All Rights Reserved.",
    icp: "Guangdong ICP No. 2023139401",
  },
};
